import axios from 'axios';
import { defer, of } from 'rxjs';
import { EVENT_EDIT_ACTIONS_NAME } from 'admin-data/event/EventEdit/redux/eventEditVars';
import { eventEditMutationCompleteObservable } from 'admin-data/event/EventEdit/redux/epic/utils';
import { createStandardEventEditRequestBundle } from 'admin-data/event/EventEdit/redux/createStandardEventEditRequestBundle';
import { map } from 'rxjs/operators';
import { FIRESTORE_ENDPOINT } from 'config';
import { Auditorium } from 'extra-models/auditorium';

const bundleEventAuditoriumGetList = createStandardEventEditRequestBundle<void, Auditorium[]>({
  actionName: `${EVENT_EDIT_ACTIONS_NAME}/auditorium/bundleEventAuditoriumGetList`,
  preConditionObservableFactory: eventEditMutationCompleteObservable,

  requestFactory: ({
    eventDomain, locale, authToken,
  }) => defer(() => axios.get(`${FIRESTORE_ENDPOINT}/events/${eventDomain}/auditoriums`, {}))
    .pipe(map((resp) => resp.data.result)),

  requestResponseMapper: ({
    response, createUpdateEventEditAction,
  }) => of(createUpdateEventEditAction((eventEditState) => {
    eventEditState.fragments.auditorium.auditoriumsList = response;
  })),
});

export default bundleEventAuditoriumGetList;
